// TẢI ẢNH LÊN KHO ẢNH ngay tại chỗ dùng (17/10/2026, thẻ "Thiết lập nhanh") — cùng API với trang Kho ảnh (POST /api/kho-anh, kho-anh.ts):
// trình duyệt thu nhỏ ≤ 1024 px, MỘT ảnh / yêu cầu, mỗi tệp một mã yêu cầu (bấm 2 lần / thử lại không nhân đôi), cùng nội dung đã có → trả ảnh cũ ("trùng").
// Trả mã ảnh (ka-…) của mọi tệp lên được (kể cả trùng) để nơi gọi thêm vào tập anh_chon; tệp lỗi nằm trong `loi` kèm lý do tiếng Việt.
import { api, ApiError, errMsg } from "../api";
import { KA_TEP_GOC_TOI_DA } from "../../../../src/shared/kho-anh";
import { thuNhoAnh } from "./san-pham";
import { kbChu, type AnhKhoWeb } from "./chon-anh";

const DUOI_NHAN = /\.(jpe?g|png|webp)$/i;
const MIME_NHAN = ["image/jpeg", "image/png", "image/webp"];
const maYeuCau = (): string => `ka-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export interface KqTaiAnh { ids: string[]; moi: number; trung: number; loi: { ten: string; lyDo: string }[] }

export async function taiAnhLenKho(files: File[], o: { album?: string; nhan?: string; conSong?: () => boolean } = {}): Promise<KqTaiAnh> {
  const kq: KqTaiAnh = { ids: [], moi: 0, trung: 0, loi: [] };
  for (const f of files) {
    if (o.conSong && !o.conSong()) break;
    const ten = f.name || "ảnh";
    const dungLoai = MIME_NHAN.includes(f.type) || (!f.type && DUOI_NHAN.test(f.name));
    if (!dungLoai) { kq.loi.push({ ten, lyDo: "chỉ nhận ảnh JPG, PNG hoặc WebP" }); continue; }
    if (!f.size) { kq.loi.push({ ten, lyDo: "tệp rỗng (0 byte)" }); continue; }
    if (f.size > KA_TEP_GOC_TOI_DA) { kq.loi.push({ ten, lyDo: `tệp quá lớn (${kbChu(f.size)}) — tối đa ${Math.round(KA_TEP_GOC_TOI_DA / 1048576)} MB` }); continue; }
    try {
      const dataUrl = await thuNhoAnh(f);
      const r = await api<{ anh: AnhKhoWeb; trung: boolean }>("POST", "/api/kho-anh", { anh: dataUrl, tenTep: ten, album: o.album ?? "", nhan: o.nhan ?? "", yeuCauId: maYeuCau() });
      if (!kq.ids.includes(r.anh.id)) kq.ids.push(r.anh.id);
      if (r.trung) kq.trung++; else kq.moi++;
    } catch (e) {
      kq.loi.push({ ten, lyDo: e instanceof ApiError && e.code === "network" ? "mất mạng — chưa gửi được" : errMsg(e).replace(/^Ảnh “[^”]*” /, "") });
    }
  }
  return kq;
}
